import { Button } from '..'

import { IconSaveSvg, PrinterSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

type ServicesHeaderProps = {
  title: string
  onClick?: any
  onPrinter?: any
  onReset?: any
  disabled?: boolean
  hasPrinter?: boolean
  hasReset?: boolean
}

const ServicesHeader = ({
  title,
  onClick,
  onPrinter,
  onReset,
  disabled = false,
  hasPrinter = false,
  hasReset = false
}: ServicesHeaderProps) => (
  <S.Wrapper className="no-print">
    <h1>{title}</h1>
    {hasReset && (
      <div>
        <Button
          onClick={onClick}
          initialIcon={<IconSaveSvg />}
          disabled={disabled}
        >
          Salvar
        </Button>
        <Button hasredButton onClick={onReset}>
          Resetar
        </Button>
      </div>
    )}
    {hasPrinter && (
      <div>
        <Button
          onClick={onClick}
          initialIcon={<IconSaveSvg />}
          disabled={disabled}
        >
          Salvar
        </Button>
        <Button initialIcon={<PrinterSvg />} onClick={onPrinter}>
          Imprimir
        </Button>
      </div>
    )}
    {!hasPrinter && !hasReset && (
      <Button
        onClick={onClick}
        initialIcon={<IconSaveSvg />}
        disabled={disabled}
      >
        Salvar
      </Button>
    )}
  </S.Wrapper>
)

export default ServicesHeader
